module.exports = __webpack_public_path__ + "img/ic_folder.e24db97c.svg";